export default "__VITE_ASSET__32d63a5b__"